export default __webpack_public_path__ + "static/media/applications-image-20.e9957073.jpg";